const firebaseConfig = {
  apiKey: "AIzaSyCt6YhhzTxkm3yUG6-luYgN66JDAwrYpzc",
  authDomain: "assignment-11-106b7.firebaseapp.com",
  projectId: "assignment-11-106b7",
  storageBucket: "assignment-11-106b7.appspot.com",
  messagingSenderId: "357737648314",
  appId: "1:357737648314:web:5d74390cab6fc4c7ee3283",
};
export default firebaseConfig;
